export const logoUrl = 'https://media-manager-c.questera.ai/greta-media/29d79c4109d1c19c2e75790b8e50872c9a33c9d5ce79f6f43f60effe48b91ada6d4fe9244bdd866a6b5eb503d1d2a9a7/images/aW1hZ2UvcG5n/a5f93310d8d8fa20c79c4df75ab9934f.png';

export const images = {
  hero: 'https://cloud.sharemyimage.com/2026/09/25/Hero.png',
  story: 'https://cloud.sharemyimage.com/2026/09/25/Our-Story-image.png',
  thread: 'https://cloud.sharemyimage.com/2026/09/25/Every-Thread-Tells-a-Story.png',
  detail: 'https://cloud.sharemyimage.com/2026/09/25/Close-up-of-luxurious-golden-silk-saree.png',
  about: 'https://cloud.sharemyimage.com/2026/09/25/About-ZEVI-image.png'
};

export const products = [
  {
    name: 'ZEVI Royal Gold',
    slug: 'zevi-royal-gold',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Royal-Gold.png',
    price: 24500
  },
  {
    name: 'ZEVI Noir',
    slug: 'zevi-noir',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Noir.png',
    price: 28500
  },
  {
    name: 'ZEVI Heritage',
    slug: 'zevi-heritage',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Heritage.png',
    price: 28500
  },
  {
    name: 'ZEVI Signature',
    slug: 'zevi-signature',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Signature.png',
    price: 28500
  },
  {
    name: 'ZEVI Elegance',
    slug: 'zevi-elegance',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Elegance.png',
    price: 26500
  },
  {
    name: 'ZEVI Classic',
    slug: 'zevi-classic',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Classic.png',
    price: 21500
  },
  {
    name: 'ZEVI Royal Heritage',
    slug: 'zevi-royal-heritage',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Royal-Heritage.png',
    price: 26500
  },
  {
    name: 'ZEVI Ivory',
    slug: 'zevi-ivory',
    image: 'https://cloud.sharemyimage.com/2026/09/25/ZEVI-Ivory.png',
    price: 28500
  }
];

export function formatCurrency(value) {
  return `Rs. ${Number(value || 0).toLocaleString('en-LK')}`;
}